import { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import { serverFile } from '../../services/file.service'

interface SlideshowProps {
  images: string[]
  interval: number
  transition: 'fade' | 'slide'
}

const Slideshow = ({ images, interval, transition }: SlideshowProps) => {
  const [currentIndex, setCurrentIndex] = useState(0)

  useEffect(() => {
    if (images.length <= 1) return

    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length)
    }, interval * 1000)

    return () => clearInterval(timer)
  }, [images.length, interval])

  if (images.length === 0) {
    return null
  }

  return (
    <SlideshowContainer transition={transition}>
      {images.map((imageUrl, index) => (
        <Slide
          key={index}
          imageUrl={serverFile(imageUrl)}
          isActive={index === currentIndex}
          transition={transition}
        />
      ))}
    </SlideshowContainer>
  )
}

const SlideshowContainer = styled.div<{ transition: string }>`
  position: relative;
  width: 100%;
  height: 728px;
  overflow: hidden;
`

const Slide = styled.div<{ imageUrl: string; isActive: boolean; transition: string }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${(props) => props.imageUrl});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  opacity: ${(props) => (props.isActive ? 1 : 0)};
  transition: opacity 1s ease-in-out;
  z-index: ${(props) => (props.isActive ? 1 : 0)};

  ${(props) =>
    props.transition === 'slide' &&
    `
    transform: translateX(${props.isActive ? '0%' : '100%'});
    transition: transform 1s ease-in-out, opacity 1s ease-in-out;
  `}
`

export default Slideshow
